// src/elements/Brand/generated/impressto-brands.types.ts
var NAME_MAP = {
  "impressto-fr": "impressto-fr"
};
export { NAME_MAP };